import { toast } from "react-toastify";
import api from "../../api";

const getErrorMessage = (error, fallback) =>
  error.response?.data?.friendly_message ||
  error.response?.data?.message ||
  error.message ||
  fallback;

const normalizeListResponse = (data) => {
  if (Array.isArray(data)) return data;
  if (Array.isArray(data?.results)) return data.results;
  if (Array.isArray(data?.items)) return data.items;
  if (Array.isArray(data?.data)) return data.data;
  if (Array.isArray(data?.stores)) return data.stores;
  if (Array.isArray(data?.users)) return data.users;
  if (Array.isArray(data?.employees)) return data.employees;

  return [];
};

export class ImpersonationModel {
  getStores = async () => {
    try {
      const { data } = await api.get("impersonation/stores");
      return normalizeListResponse(data);
    } catch (error) {
      toast.error(getErrorMessage(error, "Não foi possível carregar as lojas."), { theme: "colored" });
      return false;
    }
  };

  getUsersByStore = async (storeId) => {
    try {
      const { data } = await api.get(`impersonation/stores/${storeId}/users`);
      return normalizeListResponse(data);
    } catch (error) {
      toast.error(getErrorMessage(error, "Não foi possível carregar os usuários da loja."), { theme: "colored" });
      return false;
    }
  };

  start = async ({ storeId, userId }) => {
    try {
      const { data } = await api.post("impersonation/start", {
        storeId,
        userId,
      });

      return data;
    } catch (error) {
      toast.error(getErrorMessage(error, "Não foi possível iniciar o acesso como usuário."), { theme: "colored" });
      return false;
    }
  };

  stop = async () => {
    try {
      await api.post("impersonation/stop");
      return true;
    } catch (error) {
      return false;
    }
  };
}
